<template>
  <div class="r-input-container w-full relative">
    <input
      :value="modelValue"
      @input="updateValue"
      type="text"
      :maxlength="maxlength"
      :autofocus="autofocus"
      :class="['r-input w-full border-1.5 px-2 py-2 text-base', props.rounded ? 'rounded-full' : 'rounded']"
      placeholder=" " />
    <label class="r-input-label text-gray-500">{{ placeholder }}</label>
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  maxlength: {
    type: [String, Number],
    default: undefined
  },
  autofocus: {
    type: Boolean,
    default: false
  },
  rounded: {
    type: Boolean,
    default: false,
    required: false
  }
})

const emit = defineEmits(['update:modelValue', 'input'])

const updateValue = (event) => {
  emit('update:modelValue', event.target.value)
  emit('input', event)
}
</script>
<style scoped>
.r-input-container {
  position: relative;
}

.r-input {
  border-color: #ccc;
  background: transparent;
  outline: none;
}

.r-input:focus {
  border-color: black !important;
  outline: none;
}

.r-input-label {
  position: absolute;
  top: 50%;
  left: 0.75rem;
  transform: translateY(-50%);
  pointer-events: none;
  transition: 0.3s ease;
  padding: 0 0.25rem;
}

.r-input:focus ~ .r-input-label,
.r-input:not(:placeholder-shown) ~ .r-input-label {
  top: 0;
  left: 0.5rem;
  font-size: 0.8rem;
  @apply text-second bg-base;
  transform: translateY(-50%);
}

.r-input::placeholder {
  color: transparent;
}

@supports (-webkit-touch-callout: none) {
  .r-input:focus ~ .r-input-label,
  .r-input:not(:placeholder-shown) ~ .r-input-label {
    top: 0;
    left: 0.5rem;
    font-size: 0.8rem;
    @apply text-second bg-base;
    transform: translateY(-50%);
  }
}
</style>
